<template>
  <nav>
    <div class="nav-wrapper blue">
      <div class="container heading">
        <router-link to="/">Employee Management System</router-link>
      </div>
    </div>
  </nav>
</template>

<script>
export default {};
</script>

<style>
.heading {
  font-size: 24px;
}
</style>